/*
 * @Author: chengunghua
 * @Date: 2020-07-20
 * @LastEditors: chengunghua
 * @LastEditTime: 2020-07-20
 * @Description: wbht'
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const wbhtManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/wbht`, { params: params }); },
  // 获取客户名称
  getKhmc: () => { return axios.get(`${iffApi}/wbkh`); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/wbht/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/wbht`, fd); },

  // 修改
  update: (id, fd) => { return axios.put(`${iffApi}/wbht/${id}`, fd); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/wbht/${id}`); },

  // 获取附件信息
  getFileInfo: (htbh) => { return axios.get(`${iffApi}/wbht/getFileInfo/${htbh}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/wbht/export`, { responseType: 'blob', params }); }
};
